import { render, staticRenderFns } from "./CommandOcpp.vue?vue&type=template&id=2572953c"
import script from "./CommandOcpp.vue?vue&type=script&lang=js"
export * from "./CommandOcpp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports